<template>
  <footer class="app-global-footer">
    <span>Orderly</span>
    <span class="app-global-footer__dot">•</span>
    <span>Keep It Simple, Do It Orderly</span>
    <span class="app-global-footer__spacer"></span>
    <span>{{ year }}</span>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.app-global-footer {
  min-height: 44px;
  border-top: 1px solid rgba(153, 152, 153, 0.2);
  background: #ffffff;
  color: #6b7280;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
}

.app-global-footer__dot {
  color: #9ca3af;
}

.app-global-footer__spacer {
  flex: 1;
}
</style>
